/** */
import {
  ADD_MANY_ANNOUNCEMENTS_TO_STORE,
  ADD_ONE_ANNOUNCEMENT_TO_STORE,
  ADD_ANNOUNCEMENT_SEARCH_RESULTS_TO_STORE,
  REMOVE_ONE_ANNOUNCEMENT_FROM_STORE
} from '../actions/announcement';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = state;

  switch (type) {
    case ADD_MANY_ANNOUNCEMENTS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (announcements, announcement) => ({
            ...announcements,
            [announcement.id]: announcement
          }),
          {}
        )
      };
    case ADD_ONE_ANNOUNCEMENT_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_ANNOUNCEMENT_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (announcements, announcement) => ({
            ...announcements,
            [announcement.id]: announcement
          }),
          {}
        )
      };
    case REMOVE_ONE_ANNOUNCEMENT_FROM_STORE:
      delete current_state[payload];
      return { ...current_state };
    default:
      return state;
  }
};
